import io from 'socket.io-client';
import DeviceController from './controller/device';
import ApplianceDeviceController from './controller/appliance-device';
import NotificationController from './controller/notification';

export default (store, HOST) => {
  const socket = io.connect(HOST);

  socket.on('connect', () => {
    socket
      .emit('authenticate', { token: localStorage.getItem('auth') })
      .on('authenticated', () => {
        NotificationController.initStore(store);
      })
      .on('unauthorized', msg => {
        console.log(`unauthorized: ${JSON.stringify(msg.data)}`);
      });
  });

  socket.on('livedata', data => {
    if (DeviceController.getDevice(store, data.uid) ||
        ApplianceDeviceController.isApplianceCardsPage(store, data.uid) ||
        ApplianceDeviceController.isApplianceOverviewPage(store, data.uid)) {
      socket.emit('device', { uid: data.uid });
    }
  });

  socket.on('device', data => {
    if (DeviceController.getDevice(store, data.uid)) {
      DeviceController.setDevice(store, data);
    }
    if (ApplianceDeviceController.isApplianceCardsPage(store, data.uid)) {
      // Appliance Overview Page calls `fetchApplianceDevices` and `fetchApplianceDevicesDetailed`
      // both use `APPLIANCE_DEVICES_FETCH_SUCCEEDED` triggered by `updateApplianceCardsPage`
      // TODO: Refactor Appliance Overview Page store and actions.

      // ApplianceDeviceController.updateApplianceCardsPage(store, data);
    }
    if (ApplianceDeviceController.isApplianceOverviewPage(store, data.uid)) {
      // ApplianceDeviceController.updateApplianceOverviewPage(store, data);
    }
  });

  socket.on('notification:ex', data => {
    const { account: { siteMsg } } = store.getState();
    if (siteMsg) {
      if (data.excursion === 'appliance') {
        socket.emit('appliance:page:ex', data);
      } else {
        socket.emit('shipment:page:ex', data);
      }
    }
  });

  socket.on('shipment:page:ex', (data, shipmentId, shipmentLabel) => {
    NotificationController.sendNotification(data, shipmentId, shipmentLabel);
  });

  socket.on('appliance:page:ex', (data, applianceId, applianceLabel) => {
    NotificationController.sendNotification(data, applianceId, applianceLabel, 'appliance');
  });

  return socket;
};
